"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var recommended_import_category_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/recommended_import_category"));
var mobx_1 = require("mobx");
var google_analytics_manager_1 = __importDefault(require("@hikakaku/shared/util/google_analytics_manager"));
var RecommendedImportCategoryStore = /** @class */ (function () {
    function RecommendedImportCategoryStore(props) {
        var _this = this;
        this.component = recommended_import_category_1.default;
        this.handleCardClick = function () {
            google_analytics_manager_1.default.postGAEventWithValue('click', '査定ページ', 'リコメンド', String(_this.importCategoryId));
            _this.handleClick(_this.importCategoryId, _this.importCategoryGroupId);
        };
        this.importCategoryId = props.importCategory.id;
        this.importCategoryGroupId = props.importCategory.groupId;
        this.name = props.importCategory.name;
        this.imageUrl = props.importCategory.imageUrl;
        this.handleClick = props.onClick;
    }
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], RecommendedImportCategoryStore.prototype, "handleCardClick", void 0);
    return RecommendedImportCategoryStore;
}());
exports.default = RecommendedImportCategoryStore;
